import type { TabsForWorkspace } from 'state/workspaces/model';

import type { RealtimeQuoteBcsProduct } from './bcsProduct.model';

export type SecondaryMarketProductActions =
  | SecondaryMarketBcsProductFetchRequested
  | SecondaryMarketBcsProductDetailFetched
  | SecondaryMarketBcsProductFetchFailed;

// ////////////////////////////////////
export function secondaryMarketBcsProductFetchRequested(
  tabId: string,
  tabType: TabsForWorkspace['secondaryMarketQuotes'],
  key: string,
) {
  return { type: 'SECONDARY_MARKET_BCS_PRODUCT_FETCH_REQUESTED' as const, tabId, tabType, key };
}

export type SecondaryMarketBcsProductFetchRequested = ReturnType<typeof secondaryMarketBcsProductFetchRequested>;

// ////////////////////////////////////

export function secondaryMarketBcsProductFetched(key: string, data: RealtimeQuoteBcsProduct) {
  return { type: 'SECONDARY_MARKET_BCS_PRODUCT_FETCHED' as const, key, data };
}

export type SecondaryMarketBcsProductDetailFetched = ReturnType<typeof secondaryMarketBcsProductFetched>;

///////////////////////////////////////////////

export function secondaryMarketBcsProductFetchFailed(key: string, message: string) {
  return { type: 'SECONDARY_MARKET_BCS_PRODUCT_FETCH_FAILED' as const, key, message };
}

export type SecondaryMarketBcsProductFetchFailed = ReturnType<typeof secondaryMarketBcsProductFetchFailed>;
